import type { CounterProps } from './Counter.typed';
import * as Styled from './Counter.styled';

export const Counter = (props: CounterProps) => {
  const { counter, max, className } = props;
  return (
    <Styled.Counter className={className}>
      {counter} / {max}
    </Styled.Counter>
  );
};

export default Counter;
